import './assets/main.css'
import './axios'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVfm } from 'vue-final-modal'
import 'vue-final-modal/style.css'
import * as Sentry from "@sentry/vue"

import App from './App.vue'
import router from './router'

const app = createApp(App)

// Initialize Sentry
Sentry.init({
  app,
  dsn: "https://b6e7438e87e3e9f7c621c948f1865d89@o4508881162272768.ingest.us.sentry.io/4508881164238848",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample rate at 10%
  replaysOnErrorSampleRate: 1.0, // 100% when errors occur
})

app.use(createPinia())
app.use(router)
app.use(createVfm())
app.mount('#app')